import { useContext } from 'react';

import { ShigoThemeContext } from './theme-context';

export function useShigoTheme() {
  const value = useContext(ShigoThemeContext);
  if (!value) {
    throw new Error('Shigo theme provider was not found.');
  }
  return value;
}
